import {ImgLabel} from "@/store/model/ImgLabel";
import {formatZonedDateTime} from "@/baseUtils";
import {Email} from "@/store/model/Email";
import {LocalDate} from "@js-joda/core";

export class MemberProfile {

    constructor(data) {
        this.id = data.id;
        this.status = data.status; // BiActiveState
        this.user = new ImgLabel(data.user);
        this.firstName = data.firstName;
        this.middleName = data.middleName;
        this.lastName = data.lastName;
        this.gender = data.gender; // UserGender
        this.birthday = data.birthday ? LocalDate.parse(data.birthday) : null;
        this.about = data.about;
        this.webSite = data.webSite;
        this.emails = data.emails.map((email) => new Email(email));
        this.createdDateTime = formatZonedDateTime(data.createdDateTime);
        this.updatedDateTime = formatZonedDateTime(data.updatedDateTime);
        this.lastLoginDate = formatZonedDateTime(data.lastLoginDate);
    }
}